import styled from 'styled-components';

import UnstyledButton from 'components/unstyled-button';

export const IconsContainer = styled.div`
  display: flex;
`;

export const StoreIconWrap = styled.div`
  margin: 0 1rem 0 0;
  cursor: pointer;
  line-height: 0;

  &:last-child {
    margin-right: 0;
  }
`;

export const UnstyledButtonNoSpacing = styled(UnstyledButton)`
  margin: 0;
  padding: 0;
  line-height: 0;
`;
